import React from 'react';
import PropTypes from 'prop-types';

import '../styles/ChangeResetMenu.css';
import MenuHeader from './MenuHeader';

const ChangeResetMenu = ({ name, parentName, settings, index }) => {
    return (
      <>
        <MenuHeader itemName={name} parentItemName={parentName} />
        <div className="Change-reset-screen">
          <div className="Change-reset-output">{settings[0]}</div>
  
          <div className="Change-reset-buttons-container">
            <div className={`Set-button ${index === 0 ? "Button-active" : ""}`}>Change</div>
            <div className={`Set-button ${index === 1 ? "Button-active" : ""}`}>Reset</div>
            <div className={`Set-button ${index === 2 ? "Button-active" : ""}`}>Cancel</div>
          </div>
        </div>
      </>
    );
  };
  
ChangeResetMenu.propTypes = {
    name: PropTypes.string,
    settings: PropTypes.arrayOf(PropTypes.string),
    parentName: PropTypes.string,
    index: PropTypes.number.isRequired,
};

export default ChangeResetMenu;